// @ts-nocheck
import type * as Types from '../../../types/graphql/index';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type SignUpWithGmailMutationVariables = Types.Exact<{
  input: Types.SignUpWithGmailInput;
}>;


export type SignUpWithGmailMutation = { __typename?: 'Mutation', signUpWithGmail: { __typename?: 'AuthResult', accessToken: string } };


export const SignUpWithGmailDocument = /*#__PURE__*/ gql`
    mutation SignUpWithGmail($input: SignUpWithGmailInput!) {
  signUpWithGmail(input: $input) {
    accessToken
  }
}
    `;

/**
 * __useSignUpWithGmailMutation__
 *
 * To run a mutation, you first call `useSignUpWithGmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignUpWithGmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signUpWithGmailMutation, { data, loading, error }] = useSignUpWithGmailMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignUpWithGmailMutation(baseOptions?: Apollo.MutationHookOptions<SignUpWithGmailMutation, SignUpWithGmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignUpWithGmailMutation, SignUpWithGmailMutationVariables>(SignUpWithGmailDocument, options);
      }
export type SignUpWithGmailMutationHookResult = ReturnType<typeof useSignUpWithGmailMutation>;